import { ApiAssetWeight } from '../../../api'
import { ModelPortfolio } from '../modules/03-portfolio/types'

export const getInvestmentWeightBasedOnTargetWeight = (
  portfolio: ModelPortfolio,
  targetAssetWeight: ApiAssetWeight
) => portfolio.investmentWeights?.find(y => y.assetId === targetAssetWeight.asset.assetId)
